import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import seeqLogoPreview from 'resources/img/Seeq_preview_logo_white@2x.png';
import seeqLogoWhite2026 from 'resources/img/seeq_logo_white_2026_sm_padding.png';
import { SeeqLogo2026 } from '@/core/SeeqLogoWhite.atom';
import { WrapperWithLink } from '@/core/WrapperWithLink.atom';
import { getWorkbooksLink } from '@/main/routing.utilities';
import { isSeeqPreviewEnabled } from '@/services/systemConfiguration.utilities';
import { resetWorkbookType, setWorkbookDisplayMode } from '@/workbook/workbook.actions';
import { WORKBOOK_DISPLAY } from '@/workbook/workbook.constants';

interface HeaderLogoProps {
  ignoreConfigError?: boolean;
  disableLink?: boolean;
}

const seeqPreviewEnabled = (ignoreConfigError: boolean) => {
  try {
    return isSeeqPreviewEnabled();
  } catch (e) {
    if (ignoreConfigError) {
      return false;
    }
    throw e;
  }
};
export const HeaderLogo = ({ ignoreConfigError = false, disableLink = false }: HeaderLogoProps) => {
  const navigate = useNavigate();

  const gotoHomeScreen = () => {
    resetWorkbookType();
    navigate(getWorkbooksLink());
    setWorkbookDisplayMode(WORKBOOK_DISPLAY.EDIT);
  };

  const previewEnabled = seeqPreviewEnabled(ignoreConfigError);

  return (
    <div className={clsx('headerLogo', previewEnabled ? 'tw:w-sq-130' : 'tw:w-sq-80')} data-testid="headerLogo">
      <WrapperWithLink link={getWorkbooksLink()}>
        <div className={clsx('navbar-nav tw:pr-0 tw:pl-0', disableLink ? 'tw:cursor-default' : 'cursorPointer')}>
          <SeeqLogo2026
            className="tw:mt-1 tw:mr-sq-15 tw:mb-sq-5 tw:ml-sq-5"
            onClick={disableLink ? undefined : gotoHomeScreen}
            src={previewEnabled ? seeqLogoPreview : seeqLogoWhite2026}
            width={previewEnabled ? 130 : 80}
          />
        </div>
      </WrapperWithLink>
    </div>
  );
};
